<template>
  <div id="app">
    <nav-top></nav-top>
    <router-view/>
    <Xfooter></Xfooter>
  </div>
</template>
<script>
import NavTop from '@/components/navigation-top'
import Xfooter from '@/components/footer'
import { mapActions } from 'vuex'
export default {
  components: { NavTop, Xfooter },
  data() {
    return {
      width: '100%'
    }
  },
  created() {
    this.getConfig()
    this.getFoundationOne()
    this.getIncidentAll()
    this.getPressCenter()
  },
  methods: {
    ...mapActions('data', { getConfig: 'getConfig', getFoundationOne: 'getFoundationOne', getIncidentAll: 'getIncidentAll', getPressCenter: 'getPressCenter' })
  }
}
</script>
<style lang="scss">
  @import url('~@/assets/iconfont.css');
  * {
    padding: 0;
    margin: 0;
  }
  html,body,#app {
    min-height: 100%;
    // overflow-x: hidden;
  }
  img {
    width: 100%;
    display: block;
    // object-fit: cover;
    pointer-events: none;
  }
  .a{
    text-decoration: none;
    color: inherit;
    cursor: pointer;
  }
  .a:hover{
    color: rgb(145, 0, 0);
    text-decoration:underline;
  }
  .content-h {
    margin-bottom: 60px;
    img {
      max-width: 100%;
      width: auto;
      text-align: center;
      display: inline-block;
    }
  }
</style>
